import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: 100%;
  margin-bottom: 16px;
  position: relative;

  display: flex;
  justify-content: space-between;
  align-items: center;

  ${props =>
    props.loading &&
    css`
      width: 100%;
      height: 100px;
    `}
`;

export const Totalizador = styled.div`
  height: 56px;
  width: 12%;
  padding: 12px 36px;

  border-radius: 8px;
  color: ${props => props.textColor};
  background-color: ${props => props.backgroundColor};

  display: flex;
  align-items: center;
  justify-content: center;

  p {
    margin: 0;
    line-height: 16px;
  }
`;

export const TotalizadorNum = styled.p`
  font-weight: 400;
  font-size: 24px;
  line-height: 22px;
`;

export const Divisor = styled.div`
  height: 24px;
  margin: 0 8px;
  border: 1px solid ${props => props.borderColor};
  background: ${props => props.borderColor};
`;

export const TotalizadorNome = styled.p`
  font-weight: 400;
  font-size: 12px;
  line-height: 22px;
`;

export const LoadingContainer = styled.div`
  position: absolute;

  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  background-color: rgba(250, 250, 250, 0.9);
`;
